import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    slots: {
        error: 'pl-5'
    }
} satisfies NuxtUiTheme['formField'];
